var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerHelmet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "football-helmet copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.0-Practices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1b-1-Historical-Practice-Ball-Performance-Group-By-On",
    transform: "translate(-935.000000, -64.000000)",
    fill: "#00658B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(880.500000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "football-helmet-copy-2",
    transform: "translate(47.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125,8.95081967 L9.72070313,8.95081967 L9.30507813,6.7704918 L13.0457031,6.25983607 C13.2917969,6.22540984 13.4722656,5.97868852 13.4257813,5.72336066 C12.7476563,2.14016393 9.51289063,-0.476229508 5.79414063,0.0745901639 C2.86015625,0.507786885 0.48671875,3.00081967 0.07109375,6.07909836 C-0.2078125,8.14754098 0.363671875,10.0696721 1.46835938,11.529918 C1.553125,11.6418033 1.68164063,11.704918 1.81835938,11.704918 L3.28125,11.704918 L5.62460938,12.9959016 C6.31367188,13.357377 7.14765625,13.2168033 7.69453125,12.6430328 C8.684375,11.6045082 7.99257813,10.2934426 7.83125,9.86885246 L9.00429688,9.86885246 L9.2640625,11.2258197 C9.52382813,12.5856557 10.5765625,13.6729508 11.8863281,13.845082 C13.0894531,14.0028689 13.0484375,14 13.125,14 C13.7402344,14 14,13.4348361 14,13.0819672 L14,9.86885246 C14,9.36106557 13.6089844,8.95081967 13.125,8.95081967 Z M4.8125,10.0983607 C4.44882813,10.0983607 4.15625,9.79139344 4.15625,9.40983607 C4.15625,9.02827869 4.44882813,8.72131148 4.8125,8.72131148 C5.17617188,8.72131148 5.46875,9.02827869 5.46875,9.40983607 C5.46875,9.79139344 5.17617188,10.0983607 4.8125,10.0983607 Z M7.48125,8.95081967 L7.19960938,8.21352459 C6.98632813,7.65696721 7.33359375,7.04016393 7.89960938,6.96270492 L8.43554688,6.88811475 L8.82929688,8.95081967 L7.48125,8.95081967 Z M13.125,13.0819672 L11.9957031,12.9327869 C11.2875,12.8409836 10.6832031,12.3963115 10.3523438,11.7651639 L13.125,11.7651639 L13.125,13.0819672 Z M13.125,10.7868852 L10.0707031,10.7868852 L9.89570313,9.86885246 L13.125,9.86885246 L13.125,10.7868852 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerHelmet);
export default __webpack_public_path__ + "static/media/player_helmet.a8e90bda49877ed9c534095bf2d35308.svg";
export { ForwardRef as ReactComponent };